import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store";
import { fetchProjects } from "@/store/projectsSlice";
import { fetchStats } from "@/store/requestsSlice";
import {
  DashboardTimeRange,
  getDashboardStartDate,
} from "@/constants/dashboard";

export function useDashboardPage() {
  const dispatch = useAppDispatch();
  const { items: projects } = useAppSelector((s) => s.projects);
  const { stats, loading } = useAppSelector((s) => s.requests);

  const [timeRange, setTimeRange] = useState<DashboardTimeRange>(
    DashboardTimeRange.D7,
  );
  const [selectedProject, setSelectedProject] = useState("");

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchStats({
        projectId: selectedProject || undefined,
        startDate: getDashboardStartDate(timeRange),
      }),
    );
  }, [dispatch, selectedProject, timeRange]);

  const totalApiKeys = useMemo(
    () => projects.reduce((sum, p) => sum + (p.apiKeys?.length || 0), 0),
    [projects],
  );

  const totalMetrics = useMemo(
    () =>
      new Set(projects.flatMap((p) => p.metrics?.map((m) => m.id) || [])).size,
    [projects],
  );

  return {
    projects,
    stats,
    loading,
    timeRange,
    setTimeRange,
    selectedProject,
    setSelectedProject,
    totalApiKeys,
    totalMetrics,
  };
}
